/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull polaris-browser-sdk'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 1
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/osmosis-zone/Polaris%20Web/implementation/polaris-browser-sdk)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'polarisweb';

export const ApiKey: Record<Environment, string> = {
  polarisweb: '43f68726e384c32c966fdceada5f1390'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '1',
    branch: 'main',
    source: 'polaris-browser-sdk',
    versionId: 'de5aeca8-6cd6-4bde-a5bf-e764ded5ac47'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  Day?: string;
  initial_referring_domain?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | guest, email |
   */
  loggedInStatus?: "guest" | "email";
  referrer?: string;
}

export interface InsightsClickOnArticleProperties {
  author: string;
  id: string;
  isHighlight: boolean;
  tag: string;
  toToken: string;
}

export interface OffboardingCloseAccountCompletedProperties {
  reason?: string;
}

export interface OffboardingFoundBetterAlternativeProperties {
  reason?: string;
}

export interface OffboardingNoLongerNeedAccountProperties {
  reason?: string;
}

export interface OffboardingOtherProperties {
  reason?: string;
}

export interface OffboardingUnhappyWithServiceProperties {
  reason?: string;
}

export interface OnboardingCreateAccountProperties {
  /**
   * Indicates if this event is for a user that is in guest mode
   */
  isGuest: boolean;
}

export interface OnboardingCreateAccountErrorProperties {
  errorMsg: string;
}

export interface PageInteractionProperties {
  context?: string;
  key: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home, token info, route detail, insight |
   */
  page: "home" | "token info" | "route detail" | "insight";
}

export interface PageViewedProperties {
  context?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home, token info, route detail, insight |
   */
  page: "home" | "token info" | "route detail" | "insight";
  /**
   * referrer that invited a user to see a page, it's used by our referral system
   */
  referrer?: string;
}

export interface PortfolioManageWalletProperties {
  wallet: string;
}

export interface PortfolioPortfolioClosedProperties {
  /**
   * toggle state of portfolio drawer
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | networks, tokens, overview, wallets, manage-wallet, edit-wallet-name, settings, account, manage-account, edit-account-name, edit-account-email, verify-email, settings-ignored-accounts, referrals, settings-autopilot |
   */
  toggle:
    | "networks"
    | "tokens"
    | "overview"
    | "wallets"
    | "manage-wallet"
    | "edit-wallet-name"
    | "settings"
    | "account"
    | "manage-account"
    | "edit-account-name"
    | "edit-account-email"
    | "verify-email"
    | "settings-ignored-accounts"
    | "referrals"
    | "settings-autopilot";
}

export interface ReferralCodeGeneratedProperties {
  referralCode: string;
}

export interface ReferralCodeLinkedProperties {
  manual?: boolean;
  referralCode: string;
}

export interface SwapDropdownAssetSelectedProperties {
  chain: string;
  denom: string;
  tokenName: string;
}

export interface SwapPageViewedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home, token info, route detail, insight |
   */
  page: "home" | "token info" | "route detail" | "insight";
}

export interface SwapSwapCompletedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  feeValueUSD: number;
  fromChain: string;
  fromToken: string;
  fromTokenAmount: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home, token info, route detail, insight |
   */
  page: "home" | "token info" | "route detail" | "insight";
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  routeID?: string;
  /**
   * In milliseconds - elapsed time between signing txn and success txn
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  timeToSwap: number;
  toChain: string;
  toToken: string;
  toTokenAmount: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  valueUSD: number;
}

export interface SwapSwapFailedProperties {
  errorMsg: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  feeValueUSD: number;
  fromChain: string;
  fromToken: string;
  fromTokenAmount: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home, token info, route detail, insight |
   */
  page: "home" | "token info" | "route detail" | "insight";
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  routeID?: string;
  /**
   * In milliseconds - elapsed time between signing txn and success txn
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  timeToSwap: number;
  toChain: string;
  toToken: string;
  toTokenAmount: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  valueUSD: number;
}

export interface SwapSwapSignedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  feeValueUSD: number;
  fromChain: string;
  fromToken: string;
  fromTokenAmount: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home, token info, route detail, insight |
   */
  page: "home" | "token info" | "route detail" | "insight";
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  routeID?: string;
  toChain: string;
  toToken: string;
  toTokenAmount: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  valueUSD: number;
}

export interface SwapSwapStartedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  feeValueUSD: number;
  fromChain: string;
  fromToken: string;
  fromTokenAmount: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home, token info, route detail, insight |
   */
  page: "home" | "token info" | "route detail" | "insight";
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  routeID?: string;
  toChain: string;
  toToken: string;
  toTokenAmount: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  valueUSD: number;
}

export interface SwapSwapStepFailedProperties {
  errorMsg?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  feeValueUSD: number;
  fromChain: string;
  fromToken: string;
  fromTokenAmount: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home, token info, route detail, insight |
   */
  page: "home" | "token info" | "route detail" | "insight";
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  routeID?: string;
  /**
   * In milliseconds - elapsed time between signing txn and success txn
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  timeToSwap: number;
  toChain: string;
  toToken: string;
  toTokenAmount: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  valueUSD: number;
}

export interface WalletConnectWalletClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | widget, navbar, confirmation-screen, portfolio, select-token |
   */
  position: "widget" | "navbar" | "confirmation-screen" | "portfolio" | "select-token";
}

export interface WalletConnectWalletCompletedProperties {
  type: string;
  wallet: string;
}

export interface WalletRemoveFromPortfolioProperties {
  wallet: string;
}

export interface WalletViewWalletChainAddressesProperties {
  wallet: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DestinationAddressAddValidManualAddress implements BaseEvent {
  event_type = 'Destination address: add valid manual address';
}

export class DestinationAddressOpenSelector implements BaseEvent {
  event_type = 'Destination address: open selector';
}

export class DestinationAddressSelectAccount implements BaseEvent {
  event_type = 'Destination address: select account';
}

export class InsightsClickOnArticle implements BaseEvent {
  event_type = 'Insights: Click on article';

  constructor(
    public event_properties: InsightsClickOnArticleProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OffboardingCloseAccountCompleted implements BaseEvent {
  event_type = 'Offboarding: close account completed';

  constructor(
    public event_properties?: OffboardingCloseAccountCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OffboardingFoundBetterAlternative implements BaseEvent {
  event_type = 'Offboarding: found better alternative';

  constructor(
    public event_properties?: OffboardingFoundBetterAlternativeProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OffboardingNoLongerNeedAccount implements BaseEvent {
  event_type = 'Offboarding: no longer need account';

  constructor(
    public event_properties?: OffboardingNoLongerNeedAccountProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OffboardingOther implements BaseEvent {
  event_type = 'Offboarding: other';

  constructor(
    public event_properties?: OffboardingOtherProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OffboardingUnhappyWithService implements BaseEvent {
  event_type = 'Offboarding: unhappy with service';

  constructor(
    public event_properties?: OffboardingUnhappyWithServiceProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OnboardingCreateAccount implements BaseEvent {
  event_type = 'Onboarding: create account';

  constructor(
    public event_properties: OnboardingCreateAccountProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class OnboardingCreateAccountError implements BaseEvent {
  event_type = 'Onboarding: create account error';

  constructor(
    public event_properties: OnboardingCreateAccountErrorProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PageInteraction implements BaseEvent {
  event_type = 'Page interaction';

  constructor(
    public event_properties: PageInteractionProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PageViewed implements BaseEvent {
  event_type = 'Page Viewed';

  constructor(
    public event_properties: PageViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PortfolioAccountViewed implements BaseEvent {
  event_type = 'Portfolio: account viewed';
}

export class PortfolioManageAccount implements BaseEvent {
  event_type = 'Portfolio: manage account';
}

export class PortfolioManageWallet implements BaseEvent {
  event_type = 'Portfolio: manage wallet';

  constructor(
    public event_properties: PortfolioManageWalletProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PortfolioManageWallets implements BaseEvent {
  event_type = 'Portfolio: manage wallets';
}

export class PortfolioPortfolioClosed implements BaseEvent {
  event_type = 'Portfolio: Portfolio closed';

  constructor(
    public event_properties: PortfolioPortfolioClosedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PortfolioPortfolioOpened implements BaseEvent {
  event_type = 'Portfolio: Portfolio opened';
}

export class PortfolioReferrals implements BaseEvent {
  event_type = 'Portfolio: referrals';
}

export class PortfolioSettings implements BaseEvent {
  event_type = 'Portfolio: settings';
}

export class ReferralCodeGenerated implements BaseEvent {
  event_type = 'Referral code generated';

  constructor(
    public event_properties: ReferralCodeGeneratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReferralCodeLinked implements BaseEvent {
  event_type = 'Referral code linked';

  constructor(
    public event_properties: ReferralCodeLinkedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SwapDropdownAssetSelected implements BaseEvent {
  event_type = 'Swap: Dropdown asset selected';

  constructor(
    public event_properties: SwapDropdownAssetSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SwapPageViewed implements BaseEvent {
  event_type = 'Swap: Page viewed';

  constructor(
    public event_properties: SwapPageViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SwapSwapCompleted implements BaseEvent {
  event_type = 'Swap: Swap completed';

  constructor(
    public event_properties: SwapSwapCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SwapSwapFailed implements BaseEvent {
  event_type = 'Swap: Swap Failed';

  constructor(
    public event_properties: SwapSwapFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SwapSwapSigned implements BaseEvent {
  event_type = 'Swap: Swap signed';

  constructor(
    public event_properties: SwapSwapSignedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SwapSwapStarted implements BaseEvent {
  event_type = 'Swap: Swap started';

  constructor(
    public event_properties: SwapSwapStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SwapSwapStepFailed implements BaseEvent {
  event_type = 'Swap: Swap Step Failed';

  constructor(
    public event_properties: SwapSwapStepFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SwapSwapStepRetried implements BaseEvent {
  event_type = 'Swap: Swap Step Retried';
}

export class TokensPageViewed implements BaseEvent {
  event_type = 'Tokens: Page viewed';
}

export class WalletConnectWalletClicked implements BaseEvent {
  event_type = 'Wallet: Connect wallet clicked';

  constructor(
    public event_properties: WalletConnectWalletClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WalletConnectWalletCompleted implements BaseEvent {
  event_type = 'Wallet: Connect wallet completed';

  constructor(
    public event_properties: WalletConnectWalletCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WalletHistoryViewed implements BaseEvent {
  event_type = 'Wallet: History viewed';
}

export class WalletRemoveFromPortfolio implements BaseEvent {
  event_type = 'Wallet: remove from portfolio';

  constructor(
    public event_properties: WalletRemoveFromPortfolioProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WalletViewWalletChainAddresses implements BaseEvent {
  event_type = 'Wallet: view wallet chain addresses';

  constructor(
    public event_properties: WalletViewWalletChainAddressesProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WalletsKeplrInvalidState implements BaseEvent {
  event_type = 'Wallets: Keplr invalid state';
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Destination address: add valid manual address
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Destination%20address%3A%20add%20valid%20manual%20address)
   *
   * In destination address drawer, inputting & selecting a valid manual address.
   *
   * @param options Amplitude event options.
   */
  destinationAddressAddValidManualAddress(
    options?: EventOptions,
  ) {
    return this.track(new DestinationAddressAddValidManualAddress(), options);
  }

  /**
   * Destination address: open selector
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Destination%20address%3A%20open%20selector)
   *
   * Opening trade module to wallet icon desination address selector
   *
   * @param options Amplitude event options.
   */
  destinationAddressOpenSelector(
    options?: EventOptions,
  ) {
    return this.track(new DestinationAddressOpenSelector(), options);
  }

  /**
   * Destination address: select account
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Destination%20address%3A%20select%20account)
   *
   * In destination address drawer, selecting an account that's part of Polaris account set.
   *
   * @param options Amplitude event options.
   */
  destinationAddressSelectAccount(
    options?: EventOptions,
  ) {
    return this.track(new DestinationAddressSelectAccount(), options);
  }

  /**
   * Insights: Click on article
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Insights%3A%20Click%20on%20article)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. author)
   * @param options Amplitude event options.
   */
  insightsClickOnArticle(
    properties: InsightsClickOnArticleProperties,
    options?: EventOptions,
  ) {
    return this.track(new InsightsClickOnArticle(properties), options);
  }

  /**
   * Offboarding: close account completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Offboarding%3A%20close%20account%20completed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. reason)
   * @param options Amplitude event options.
   */
  offboardingCloseAccountCompleted(
    properties?: OffboardingCloseAccountCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OffboardingCloseAccountCompleted(properties), options);
  }

  /**
   * Offboarding: found better alternative
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Offboarding%3A%20found%20better%20alternative)
   *
   * User specified that they found better alternative
   *
   * @param properties The event's properties (e.g. reason)
   * @param options Amplitude event options.
   */
  offboardingFoundBetterAlternative(
    properties?: OffboardingFoundBetterAlternativeProperties,
    options?: EventOptions,
  ) {
    return this.track(new OffboardingFoundBetterAlternative(properties), options);
  }

  /**
   * Offboarding: no longer need account
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Offboarding%3A%20no%20longer%20need%20account)
   *
   * User specified that they no longer need an account
   *
   * @param properties The event's properties (e.g. reason)
   * @param options Amplitude event options.
   */
  offboardingNoLongerNeedAccount(
    properties?: OffboardingNoLongerNeedAccountProperties,
    options?: EventOptions,
  ) {
    return this.track(new OffboardingNoLongerNeedAccount(properties), options);
  }

  /**
   * Offboarding: other
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Offboarding%3A%20other)
   *
   * User specified "other" during offboarding and provided a free text 
   *
   * reason.
   *
   * @param properties The event's properties (e.g. reason)
   * @param options Amplitude event options.
   */
  offboardingOther(
    properties?: OffboardingOtherProperties,
    options?: EventOptions,
  ) {
    return this.track(new OffboardingOther(properties), options);
  }

  /**
   * Offboarding: unhappy with service
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Offboarding%3A%20unhappy%20with%20service)
   *
   * User specified that they are unhappy with service during offboarding
   *
   * @param properties The event's properties (e.g. reason)
   * @param options Amplitude event options.
   */
  offboardingUnhappyWithService(
    properties?: OffboardingUnhappyWithServiceProperties,
    options?: EventOptions,
  ) {
    return this.track(new OffboardingUnhappyWithService(properties), options);
  }

  /**
   * Onboarding: create account
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Onboarding%3A%20create%20account)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. isGuest)
   * @param options Amplitude event options.
   */
  onboardingCreateAccount(
    properties: OnboardingCreateAccountProperties,
    options?: EventOptions,
  ) {
    return this.track(new OnboardingCreateAccount(properties), options);
  }

  /**
   * Onboarding: create account error
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Onboarding%3A%20create%20account%20error)
   *
   * If there is an error creating a Polaris account
   *
   * @param properties The event's properties (e.g. errorMsg)
   * @param options Amplitude event options.
   */
  onboardingCreateAccountError(
    properties: OnboardingCreateAccountErrorProperties,
    options?: EventOptions,
  ) {
    return this.track(new OnboardingCreateAccountError(properties), options);
  }

  /**
   * Page interaction
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Page%20interaction)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  pageInteraction(
    properties: PageInteractionProperties,
    options?: EventOptions,
  ) {
    return this.track(new PageInteraction(properties), options);
  }

  /**
   * Page Viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Page%20Viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. context)
   * @param options Amplitude event options.
   */
  pageViewed(
    properties: PageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PageViewed(properties), options);
  }

  /**
   * Portfolio: account viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Portfolio%3A%20account%20viewed)
   *
   * Account button (with avatar) clicked from top level portfolio screen
   *
   * @param options Amplitude event options.
   */
  portfolioAccountViewed(
    options?: EventOptions,
  ) {
    return this.track(new PortfolioAccountViewed(), options);
  }

  /**
   * Portfolio: manage account
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Portfolio%3A%20manage%20account)
   *
   * Portfolio manage account row button clicked (Account), not to be confused by global account button (with avatar)
   *
   * @param options Amplitude event options.
   */
  portfolioManageAccount(
    options?: EventOptions,
  ) {
    return this.track(new PortfolioManageAccount(), options);
  }

  /**
   * Portfolio: manage wallet
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Portfolio%3A%20manage%20wallet)
   *
   * Wallet card clicked from wallet card list in portfolio
   *
   * @param properties The event's properties (e.g. wallet)
   * @param options Amplitude event options.
   */
  portfolioManageWallet(
    properties: PortfolioManageWalletProperties,
    options?: EventOptions,
  ) {
    return this.track(new PortfolioManageWallet(properties), options);
  }

  /**
   * Portfolio: manage wallets
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Portfolio%3A%20manage%20wallets)
   *
   * Manage wallets screen opened (clicked)
   *
   * @param options Amplitude event options.
   */
  portfolioManageWallets(
    options?: EventOptions,
  ) {
    return this.track(new PortfolioManageWallets(), options);
  }

  /**
   * Portfolio: Portfolio closed
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Portfolio%3A%20Portfolio%20closed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. toggle)
   * @param options Amplitude event options.
   */
  portfolioPortfolioClosed(
    properties: PortfolioPortfolioClosedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PortfolioPortfolioClosed(properties), options);
  }

  /**
   * Portfolio: Portfolio opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Portfolio%3A%20Portfolio%20opened)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  portfolioPortfolioOpened(
    options?: EventOptions,
  ) {
    return this.track(new PortfolioPortfolioOpened(), options);
  }

  /**
   * Portfolio: referrals
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Portfolio%3A%20referrals)
   *
   * Portfolio referrals row button clicked
   *
   * @param options Amplitude event options.
   */
  portfolioReferrals(
    options?: EventOptions,
  ) {
    return this.track(new PortfolioReferrals(), options);
  }

  /**
   * Portfolio: settings
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Portfolio%3A%20settings)
   *
   * Portfolio settings row button clicked
   *
   * @param options Amplitude event options.
   */
  portfolioSettings(
    options?: EventOptions,
  ) {
    return this.track(new PortfolioSettings(), options);
  }

  /**
   * Referral code generated
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Referral%20code%20generated)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. referralCode)
   * @param options Amplitude event options.
   */
  referralCodeGenerated(
    properties: ReferralCodeGeneratedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReferralCodeGenerated(properties), options);
  }

  /**
   * Referral code linked
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Referral%20code%20linked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. manual)
   * @param options Amplitude event options.
   */
  referralCodeLinked(
    properties: ReferralCodeLinkedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ReferralCodeLinked(properties), options);
  }

  /**
   * Swap: Dropdown asset selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Swap%3A%20Dropdown%20asset%20selected)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chain)
   * @param options Amplitude event options.
   */
  swapDropdownAssetSelected(
    properties: SwapDropdownAssetSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SwapDropdownAssetSelected(properties), options);
  }

  /**
   * Swap: Page viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Swap%3A%20Page%20viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. page)
   * @param options Amplitude event options.
   */
  swapPageViewed(
    properties: SwapPageViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SwapPageViewed(properties), options);
  }

  /**
   * Swap: Swap completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Swap%3A%20Swap%20completed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. feeValueUSD)
   * @param options Amplitude event options.
   */
  swapSwapCompleted(
    properties: SwapSwapCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SwapSwapCompleted(properties), options);
  }

  /**
   * Swap: Swap Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Swap%3A%20Swap%20Failed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. errorMsg)
   * @param options Amplitude event options.
   */
  swapSwapFailed(
    properties: SwapSwapFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SwapSwapFailed(properties), options);
  }

  /**
   * Swap: Swap signed
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Swap%3A%20Swap%20signed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. feeValueUSD)
   * @param options Amplitude event options.
   */
  swapSwapSigned(
    properties: SwapSwapSignedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SwapSwapSigned(properties), options);
  }

  /**
   * Swap: Swap started
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Swap%3A%20Swap%20started)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. feeValueUSD)
   * @param options Amplitude event options.
   */
  swapSwapStarted(
    properties: SwapSwapStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SwapSwapStarted(properties), options);
  }

  /**
   * Swap: Swap Step Failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Swap%3A%20Swap%20Step%20Failed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. errorMsg)
   * @param options Amplitude event options.
   */
  swapSwapStepFailed(
    properties: SwapSwapStepFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SwapSwapStepFailed(properties), options);
  }

  /**
   * Swap: Swap Step Retried
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Swap%3A%20Swap%20Step%20Retried)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  swapSwapStepRetried(
    options?: EventOptions,
  ) {
    return this.track(new SwapSwapStepRetried(), options);
  }

  /**
   * Tokens: Page viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Tokens%3A%20Page%20viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  tokensPageViewed(
    options?: EventOptions,
  ) {
    return this.track(new TokensPageViewed(), options);
  }

  /**
   * Wallet: Connect wallet clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Wallet%3A%20Connect%20wallet%20clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. position)
   * @param options Amplitude event options.
   */
  walletConnectWalletClicked(
    properties: WalletConnectWalletClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WalletConnectWalletClicked(properties), options);
  }

  /**
   * Wallet: Connect wallet completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Wallet%3A%20Connect%20wallet%20completed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. type)
   * @param options Amplitude event options.
   */
  walletConnectWalletCompleted(
    properties: WalletConnectWalletCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WalletConnectWalletCompleted(properties), options);
  }

  /**
   * Wallet: History viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Wallet%3A%20History%20viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  walletHistoryViewed(
    options?: EventOptions,
  ) {
    return this.track(new WalletHistoryViewed(), options);
  }

  /**
   * Wallet: remove from portfolio
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Wallet%3A%20remove%20from%20portfolio)
   *
   * Remove wallet from portfolio from manage wallet screen
   *
   * @param properties The event's properties (e.g. wallet)
   * @param options Amplitude event options.
   */
  walletRemoveFromPortfolio(
    properties: WalletRemoveFromPortfolioProperties,
    options?: EventOptions,
  ) {
    return this.track(new WalletRemoveFromPortfolio(properties), options);
  }

  /**
   * Wallet: view wallet chain addresses
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Wallet%3A%20view%20wallet%20chain%20addresses)
   *
   * View addresses list row button for viewing wallet addresses across all supported chains for a wallet
   *
   * @param properties The event's properties (e.g. wallet)
   * @param options Amplitude event options.
   */
  walletViewWalletChainAddresses(
    properties: WalletViewWalletChainAddressesProperties,
    options?: EventOptions,
  ) {
    return this.track(new WalletViewWalletChainAddresses(properties), options);
  }

  /**
   * Wallets: Keplr invalid state
   *
   * [View in Tracking Plan](https://data.amplitude.com/osmosis-zone/Polaris%20Web/events/main/latest/Wallets%3A%20Keplr%20invalid%20state)
   *
   * If a user tries to add an account while Keplr wallet connector state is invalid, we show a toast blocking the action to prevent invalid groupings of some connectors with the prior Keplr account. 
   *
   *  This event fires under that scenario.
   *
   * @param options Amplitude event options.
   */
  walletsKeplrInvalidState(
    options?: EventOptions,
  ) {
    return this.track(new WalletsKeplrInvalidState(), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
